import { render } from "./server.vue?vue&type=template&id=43230584&scoped=true"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"

import "./server.vue?vue&type=style&index=0&id=43230584&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43230584"]])

export default __exports__